import { EntityKeyConfig } from '../../../types/entities';

/**
 * Entity Keys for FITTINGS
 * 
 * Defines the key structure used throughout the application
 * for this entity type.
 */
export const keys: EntityKeyConfig = {
  single: 'fittingFamily',
  plural: 'fittingFamilies',
  state: 'fittingFamilies'
};
